module.exports = __webpack_public_path__ + "img/cliente_movistar_gris.74de1452.png";